// Bill History API actions
export const GET_BILL_HISTORY_SUCCESS = 'GET_BILL_HISTORY_SUCCESS';
export const GET_BILL_HISTORY_FAIL = 'GET_BILL_HISTORY_FAIL';
export const SET_GET_BILL_HISTORY_LOADING = 'SET_GET_BILL_HISTORY_LOADING';

// Single Bill Details API actions
export const GET_SINGLE_BILL_DATA_SUCCESS = 'GET_SINGLE_BILL_DATA_SUCCESS';
export const GET_SINGLE_BILL_DATA_FAIL = 'GET_SINGLE_BILL_DATA_FAIL';
export const SET_GET_SINGLE_BILL_DATA_LOADING = 'SET_GET_SINGLE_BILL_DATA_LOADING';
